import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import { getDate, getDobDate } from "../common/DisplayDate";
import getSsn from "../common/Ssn";
import Address from "./Address";

class ConcealedWeaponLicenseRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const nameNode = _.get(node, "name[0]");
      results.push(
        <Table.Row
          key={`ConWeap_Record_Name_Row_${this.props.index}`}
          className={this.props.index % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell width={2}>Name:</Table.Cell>
          <Table.Cell width={6}>
            {getPersonName(
              _.get(nameNode, "first[0]._", ""),
              "",
              _.get(nameNode, "last[0]._", ""),
              this.props
            )}
          </Table.Cell>
          <Table.Cell width={2}>Permit Type:</Table.Cell>
          <Table.Cell width={6}>
            {_.get(node, "permit[0].permitNumber[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      const expirationDate = _.get(node, "permit[0].expirationDate[0]");
      results.push(
        <Table.Row
          key={`ConWeap_Record_Address_Row_${this.props.index}`}
          className={this.props.index % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell width={2}>Address:</Table.Cell>
          <Table.Cell width={6}>
            <Address addressNode={_.get(node, "address[0]")} {...this.props} />
          </Table.Cell>
          <Table.Cell width={2}>Expiration Date:</Table.Cell>
          <Table.Cell width={6}>
            {expirationDate && getDate(expirationDate)}
          </Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row
          key={`ConWeap_Record_Dob_Row_${this.props.index}`}
          className={this.props.index % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell width={2}>Date of Birth</Table.Cell>
          <Table.Cell width={6}>
            {getDobDate(node, { userAccount: this.props.userAccount })}
          </Table.Cell>
          <Table.Cell> width={2}State:</Table.Cell>
          <Table.Cell width={6}>{_.get(node, "stateName[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      const registrationDate = _.get(node, "permit[0].registrationDate[0]");
      results.push(
        <Table.Row
          key={`ConWeap_Record_Ssn_Row_${this.props.index}`}
          className={this.props.index % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell width={2}>SSN:</Table.Cell>
          <Table.Cell width={6}>
            {getSsn(_.get(node, "SSN[0]._"), this.props)}
          </Table.Cell>
          <Table.Cell width={2}>Registration Date:</Table.Cell>
          <Table.Cell width={6}>
            {registrationDate && getDate(registrationDate)}
          </Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row
          key={`ConWeap_Record_Gender_Row_${this.props.index}`}
          className={this.props.index % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell width={2}>Gender:</Table.Cell>
          <Table.Cell width={6}>{_.get(node, "sex[0]._", "")}</Table.Cell>
          <Table.Cell width={2} />
          <Table.Cell width={6} />
        </Table.Row>
      );
      results.push(
        <Table.Row
          key={`ConWeap_Record_Race_Row_${this.props.index}`}
          className={this.props.index % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell width={2}>Race:</Table.Cell>
          <Table.Cell width={6}>{_.get(node, "race[0]._", "")}</Table.Cell>
          <Table.Cell width={2} />
          <Table.Cell width={6} />
        </Table.Row>
      );
    }

    return (
      <Table className="transparent">
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default ConcealedWeaponLicenseRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/ConcealedWeaponLicenseRecordDetail.js